
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("sc949", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $aXWIB = parcelRequire("aXWIB");


var $5MaNT = parcelRequire("5MaNT");


var $9QfXi = parcelRequire("9QfXi");


var $7Rcde = parcelRequire("7Rcde");


var $1oCLl = parcelRequire("1oCLl");


var $kQVmG = parcelRequire("kQVmG");

function $0ad26e2649dc7338$var$CodeBlock(props) {
    const { text: text, language: language, allowCopyToClipboard: allowCopyToClipboard = false, allowWrapCodeBlock: allowWrapCodeBlock = false, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled, hideLineNumbers: hideLineNumbers = false, localId: localId, wrap: wrap } = props;
    const codeBidiWarningLabel = props.intl.formatMessage((0, $7Rcde.codeBidiWarningMessages).label);
    const className = [
        (0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER,
        props.className
    ].join(' ');
    const [wrapLongLines, setWrapLongLines] = (0, $42omo.useState)(()=>(0, $1oCLl.expValEquals)('platform_editor_code_block_q4_lovability', 'isEnabled', true) && Boolean(wrap));
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $kQVmG.default), {
        allowCopyToClipboard: allowCopyToClipboard,
        allowWrapCodeBlock: allowWrapCodeBlock,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        localId: localId,
        setWrapLongLines: setWrapLongLines,
        text: text,
        wrapLongLines: wrapLongLines
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $9QfXi.default), {
        testId: "renderer-code-block",
        language: language,
        text: text,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled,
        shouldWrapLongLines: allowWrapCodeBlock && wrapLongLines,
        shouldShowLineNumbers: !((0, $1oCLl.expValEquals)('platform_editor_code_block_q4_lovability', 'isEnabled', true) && hideLineNumbers),
        hasBidiWarnings: (0, $1oCLl.expValEquals)('platform_editor_remove_bidi_char_warning', 'isEnabled', true) ? false : undefined
    }));
}
const $0ad26e2649dc7338$var$_default_1 = (0, $aXWIB.injectIntl)($0ad26e2649dc7338$var$CodeBlock);
var $0ad26e2649dc7338$export$2e2bcd8739ae039 = $0ad26e2649dc7338$var$_default_1;
module.exports["default"] = $0ad26e2649dc7338$export$2e2bcd8739ae039;

});

parcelRegister("kQVmG", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable @typescript-eslint/consistent-type-imports, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic */ 
var $9K4OG = parcelRequire("9K4OG");


var $5MaNT = parcelRequire("5MaNT");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $9hz8e = parcelRequire("9hz8e");

const $1577a14320481940$var$codeBlockStyleOverrides = /*#__PURE__*/ (0, $9K4OG.css)({
    tabSize: 4,
    backgroundColor: "var(--ds-surface-raised, #FFFFFF)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    button: {
        opacity: 0,
        transition: 'opacity 0.2s ease 0s'
    },
    '&:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        button: {
            opacity: 1
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`${(0, $5MaNT.CodeBlockSharedCssClassName).DS_CODEBLOCK}`]: {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${0.875}rem`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '1.5rem',
        backgroundImage: `linear-gradient(
			to right,
			${"var(--ds-background-neutral, #0515240F)"} ${"var(--ds-space-300, 24px)"},
			transparent ${"var(--ds-space-300, 24px)"}
			),linear-gradient(
			to right,
			${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-300, 24px)"},
			transparent ${"var(--ds-space-300, 24px)"}
			),linear-gradient(
			to left,
			${"var(--ds-background-neutral, #0515240F)"} ${"var(--ds-space-100, 8px)"},
			transparent ${"var(--ds-space-100, 8px)"}
			),linear-gradient(
			to left,
			${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-100, 8px)"},
			transparent ${"var(--ds-space-100, 8px)"}
			),linear-gradient(
			to left,
			${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
			),linear-gradient(
			to left,
			${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
			),linear-gradient(
			to right,
			${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
			),linear-gradient(
			to right,
			${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
			)`,
        backgroundAttachment: 'local, local, local, local, scroll, scroll, scroll, scroll',
        backgroundPosition: '0 0, 0 0, 100% 0, 100% 0, 100% 0, 100% 0, 0 0, 0 0'
    }
});
const $1577a14320481940$var$denseModeOverrides = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`${(0, $5MaNT.CodeBlockSharedCssClassName).DS_CODEBLOCK}`]: {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '0.875em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '1.5em'
    }
});
const $1577a14320481940$var$CodeBlockContainer = ({ allowCopyToClipboard: allowCopyToClipboard, allowWrapCodeBlock: allowWrapCodeBlock, children: children, className: className, localId: localId, setWrapLongLines: setWrapLongLines, text: text, wrapLongLines: wrapLongLines })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: className,
        "data-local-id": localId,
        css: [
            $1577a14320481940$var$codeBlockStyleOverrides,
            ((0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp')) && $1577a14320481940$var$denseModeOverrides
        ]
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $9hz8e.default), {
        allowCopyToClipboard: allowCopyToClipboard,
        allowWrapCodeBlock: allowWrapCodeBlock,
        setWrapLongLines: setWrapLongLines,
        text: text,
        wrapLongLines: wrapLongLines
    }), children);
};
var $1577a14320481940$export$2e2bcd8739ae039 = $1577a14320481940$var$CodeBlockContainer;
module.exports["default"] = $1577a14320481940$export$2e2bcd8739ae039;

});

parcelRegister("9hz8e", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable @typescript-eslint/consistent-type-imports, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic */ 
var $9K4OG = parcelRequire("9K4OG");


var $fHPm9 = parcelRequire("fHPm9");


var $bv6rO = parcelRequire("bv6rO");

const $a870006f5338ad0e$var$codeBlockButtonsWrapper = /*#__PURE__*/ (0, $9K4OG.css)({
    position: 'sticky',
    top: '0px',
    background: `${"var(--ds-surface, #FFFFFF)"}`
});
const $a870006f5338ad0e$var$codeBlockButtonsStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    display: 'flex',
    justifyContent: 'flex-end',
    position: 'absolute',
    height: '0',
    width: '100%',
    right: "var(--ds-space-075, 6px)",
    top: "var(--ds-space-050, 4px)",
    padding: "var(--ds-space-025, 2px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    button: {
        height: '32px',
        width: '32px',
        border: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border, #0B120E24)"}`,
        borderRadius: "var(--ds-radius-small, 4px)",
        marginLeft: "var(--ds-space-050, 4px)",
        padding: "var(--ds-space-025, 2px)",
        background: `${"var(--ds-surface-overlay, #FFFFFF)"}`,
        color: `${"var(--ds-icon, #292A2E)"}`,
        '&:hover': {
            borderWidth: "var(--ds-border-width-selected, 2px)",
            backgroundColor: `${"var(--ds-surface-overlay-hovered, #F0F1F2)"}`,
            height: '32px',
            width: '32px'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.clicked': {
            backgroundColor: `${"var(--ds-background-neutral-bold-pressed, #505258)"}`,
            borderRadius: "var(--ds-radius-small, 4px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
            color: `${"var(--ds-icon-inverse, #FFFFFF)"} !important`
        }
    }
});
const $a870006f5338ad0e$var$CodeBlockButtonContainer = ({ allowCopyToClipboard: allowCopyToClipboard, allowWrapCodeBlock: allowWrapCodeBlock, setWrapLongLines: setWrapLongLines, text: text, wrapLongLines: wrapLongLines })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $a870006f5338ad0e$var$codeBlockButtonsWrapper
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $a870006f5338ad0e$var$codeBlockButtonsStyle
    }, allowWrapCodeBlock && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bv6rO.default), {
        setWrapLongLines: setWrapLongLines,
        wrapLongLines: wrapLongLines
    }), allowCopyToClipboard && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $fHPm9.default), {
        content: text
    })));
};
var $a870006f5338ad0e$export$2e2bcd8739ae039 = $a870006f5338ad0e$var$CodeBlockButtonContainer;
module.exports["default"] = $a870006f5338ad0e$export$2e2bcd8739ae039;

});

parcelRegister("fHPm9", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $4KS7f = parcelRequire("4KS7f");


var $f8J4a = parcelRequire("f8J4a");


var $2MuFw = parcelRequire("2MuFw");


var $3gadb = parcelRequire("3gadb");


var $9K4OG = parcelRequire("9K4OG");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $6uN0A = parcelRequire("6uN0A");


var $gi5bC = parcelRequire("gi5bC");


var $kIphX = parcelRequire("kIphX");

const $890d768eb03ab16f$var$CopyButton = ({ content: content, intl: intl })=>{
    const [tooltip, setTooltip] = (0, $42omo.useState)(intl.formatMessage((0, $f8J4a.codeBlockButtonMessages).copyCodeToClipboard));
    const [className, setClassName] = (0, $42omo.useState)('copy-to-clipboard');
    const onMouseLeave = ()=>{
        setTooltip(intl.formatMessage((0, $f8J4a.codeBlockButtonMessages).copyCodeToClipboard));
        setClassName('copy-to-clipboard');
    };
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6uN0A.default).Consumer, null, ({ fireAnalyticsEvent: fireAnalyticsEvent })=>/*#__PURE__*/ (0, $9K4OG.jsx)("span", null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3gadb.default), {
            content: tooltip,
            hideTooltipOnClick: false,
            position: "top"
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            onMouseLeave: onMouseLeave,
            onBlur: onMouseLeave
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $4KS7f.default), {
            appearance: "subtle",
            "aria-haspopup": true,
            "aria-label": tooltip,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            iconBefore: /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2MuFw))), {
                label: tooltip
            }),
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onClick: (event)=>{
                fireAnalyticsEvent({
                    // @ts-expect-error - Type 'ACTION.CLICKED' is not assignable to type 'ACTION.CLICKED | ACTION.MEDIA_LINK_TRANSFORMED | ACTION.STARTED | ACTION.TOGGLE_EXPAND | ACTION.UNSUPPORTED_CONTENT_ENCOUNTERED | ACTION.VISITED | ACTION.RENDERED | ACTION.INVALID_PROSEMIRROR_DOCUMENT | ACTION.CRASHED | ... 6 more ... | AnnotationActionType'.
                    // This error was introduced after upgrading to TypeScript 5
                    action: (0, $gi5bC.ACTION).CLICKED,
                    actionSubject: (0, $gi5bC.ACTION_SUBJECT).BUTTON,
                    actionSubjectId: (0, $gi5bC.ACTION_SUBJECT_ID).CODEBLOCK_COPY,
                    eventType: (0, $gi5bC.EVENT_TYPE).UI
                });
                (0, $kIphX.copyTextToClipboard)(content);
                setTooltip(intl.formatMessage((0, $f8J4a.codeBlockButtonMessages).copiedCodeToClipboard));
                setClassName('copy-to-clipboard clicked');
                event.stopPropagation();
            },
            spacing: "compact"
        })))));
};
const $890d768eb03ab16f$var$_default_1 = (0, $aXWIB.injectIntl)($890d768eb03ab16f$var$CopyButton);
var $890d768eb03ab16f$export$2e2bcd8739ae039 = $890d768eb03ab16f$var$_default_1;
module.exports["default"] = $890d768eb03ab16f$export$2e2bcd8739ae039;

});

parcelRegister("bv6rO", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $aXWIB = parcelRequire("aXWIB");


var $aK2ZC = parcelRequire("aK2ZC");


var $4KS7f = parcelRequire("4KS7f");


var $f8J4a = parcelRequire("f8J4a");


var $3gadb = parcelRequire("3gadb");


var $6uN0A = parcelRequire("6uN0A");


var $gi5bC = parcelRequire("gi5bC");

const $e81ff9189b9a6692$var$CodeBlockWrapButton = ({ setWrapLongLines: setWrapLongLines, wrapLongLines: wrapLongLines, intl: intl })=>{
    const wrapMessage = intl.formatMessage(wrapLongLines ? (0, $f8J4a.codeBlockButtonMessages).unwrapCode : (0, $f8J4a.codeBlockButtonMessages).wrapCode);
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6uN0A.default).Consumer, null, ({ fireAnalyticsEvent: fireAnalyticsEvent })=>/*#__PURE__*/ (0, $9K4OG.jsx)("span", null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3gadb.default), {
            content: wrapMessage,
            hideTooltipOnClick: false,
            position: "top"
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $4KS7f.default), {
            appearance: "subtle",
            "aria-haspopup": true,
            "aria-label": wrapMessage,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `wrap-code ${wrapLongLines ? 'clicked' : ''}`,
            iconBefore: /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aK2ZC))), {
                label: ""
            }),
            isSelected: wrapLongLines,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onClick: (event)=>{
                fireAnalyticsEvent({
                    // @ts-expect-error - Type 'ACTION.CLICKED' is not assignable to type 'ACTION.CLICKED | ACTION.MEDIA_LINK_TRANSFORMED | ACTION.STARTED | ACTION.TOGGLE_EXPAND | ACTION.UNSUPPORTED_CONTENT_ENCOUNTERED | ACTION.VISITED | ACTION.RENDERED | ACTION.INVALID_PROSEMIRROR_DOCUMENT | ACTION.CRASHED | ... 6 more ... | AnnotationActionType'
                    // This error was introduced after upgrading to TypeScript 5
                    action: (0, $gi5bC.ACTION).CLICKED,
                    actionSubject: (0, $gi5bC.ACTION_SUBJECT).BUTTON,
                    actionSubjectId: (0, $gi5bC.ACTION_SUBJECT_ID).CODEBLOCK_WRAP,
                    attributes: {
                        wrapped: !wrapLongLines
                    },
                    eventType: (0, $gi5bC.EVENT_TYPE).UI
                });
                setWrapLongLines(!wrapLongLines);
                event.stopPropagation();
            },
            spacing: "compact"
        }))));
};
const $e81ff9189b9a6692$var$_default_1 = (0, $aXWIB.injectIntl)($e81ff9189b9a6692$var$CodeBlockWrapButton);
var $e81ff9189b9a6692$export$2e2bcd8739ae039 = $e81ff9189b9a6692$var$_default_1;
module.exports["default"] = $e81ff9189b9a6692$export$2e2bcd8739ae039;

});

parcelRegister("cTQmR", function(module, exports) {
// The full list of languages that can potentially be supported is found in
// https://prismjs.com/#supported-languages

const $a6db6a3439cd9017$export$7c77c3a9bb93870d = [
    {
        name: 'PHP',
        alias: [
            'php',
            'php3',
            'php4',
            'php5'
        ],
        value: 'php'
    },
    {
        name: 'Java',
        alias: [
            'java'
        ],
        value: 'java'
    },
    {
        name: 'CSharp',
        alias: [
            'csharp',
            'c#'
        ],
        value: 'cs'
    },
    {
        name: 'Python',
        alias: [
            'python',
            'py'
        ],
        value: 'python'
    },
    {
        name: 'JavaScript',
        alias: [
            'javascript',
            'js'
        ],
        value: 'javascript'
    },
    {
        name: 'Html',
        alias: [
            'html'
        ],
        value: 'xml'
    },
    {
        name: 'C++',
        alias: [
            'c++',
            'cpp',
            'clike'
        ],
        value: 'cpp'
    },
    {
        name: 'Ruby',
        alias: [
            'ruby',
            'rb',
            'duby'
        ],
        value: 'ruby'
    },
    {
        name: 'Objective-C',
        alias: [
            'objective-c',
            'objectivec',
            'obj-c',
            'objc'
        ],
        value: 'objectivec'
    },
    {
        name: 'C',
        alias: [
            'c'
        ],
        value: 'cpp'
    },
    {
        name: 'Swift',
        alias: [
            'swift'
        ],
        value: 'swift'
    },
    {
        name: 'TeX',
        alias: [
            'tex',
            'latex'
        ],
        value: 'tex'
    },
    {
        name: 'Shell',
        alias: [
            'shell',
            'bash',
            'sh',
            'ksh',
            'zsh'
        ],
        value: 'shell'
    },
    {
        name: 'Scala',
        alias: [
            'scala'
        ],
        value: 'scala'
    },
    {
        name: 'Go',
        alias: [
            'go'
        ],
        value: 'go'
    },
    {
        name: 'ActionScript',
        alias: [
            'actionscript',
            'actionscript3',
            'as'
        ],
        value: 'actionscript'
    },
    {
        name: 'ColdFusion',
        alias: [
            'coldfusion'
        ],
        value: 'xml'
    },
    {
        name: 'JavaFX',
        alias: [
            'javafx',
            'jfx'
        ],
        value: 'java'
    },
    {
        name: 'VbNet',
        alias: [
            'vbnet',
            'vb.net',
            'vfp',
            'clipper',
            'xbase'
        ],
        value: 'vbnet'
    },
    {
        name: 'JSON',
        alias: [
            'json'
        ],
        value: 'json'
    },
    {
        name: 'MATLAB',
        alias: [
            'matlab'
        ],
        value: 'matlab'
    },
    {
        name: 'Groovy',
        alias: [
            'groovy'
        ],
        value: 'groovy'
    },
    {
        name: 'SQL',
        alias: [
            'sql',
            'postgresql',
            'postgres',
            'plpgsql',
            'psql',
            'postgresql-console',
            'postgres-console',
            'tsql',
            't-sql',
            'mysql',
            'sqlite'
        ],
        value: 'sql'
    },
    {
        name: 'R',
        alias: [
            'r'
        ],
        value: 'r'
    },
    {
        name: 'Perl',
        alias: [
            'perl',
            'pl'
        ],
        value: 'perl'
    },
    {
        name: 'Lua',
        alias: [
            'lua'
        ],
        value: 'lua'
    },
    {
        name: 'Pascal',
        alias: [
            'pas',
            'pascal',
            'objectpascal',
            'delphi'
        ],
        value: 'pascal'
    },
    {
        name: 'XML',
        alias: [
            'xml'
        ],
        value: 'xml'
    },
    {
        name: 'TypeScript',
        alias: [
            'typescript',
            'ts'
        ],
        value: 'typescript'
    },
    {
        name: 'CoffeeScript',
        alias: [
            'coffeescript',
            'coffee-script',
            'coffee'
        ],
        value: 'coffeescript'
    },
    {
        name: 'Haskell',
        alias: [
            'haskell',
            'hs'
        ],
        value: 'haskell'
    },
    {
        name: 'Puppet',
        alias: [
            'puppet'
        ],
        value: 'puppet'
    },
    {
        name: 'Arduino',
        alias: [
            'arduino'
        ],
        value: 'arduino'
    },
    {
        name: 'Fortran',
        alias: [
            'fortran'
        ],
        value: 'fortran'
    },
    {
        name: 'Erlang',
        alias: [
            'erlang',
            'erl'
        ],
        value: 'erlang'
    },
    {
        name: 'PowerShell',
        alias: [
            'powershell',
            'posh',
            'ps1',
            'psm1'
        ],
        value: 'powershell'
    },
    {
        name: 'Haxe',
        alias: [
            'haxe',
            'hx',
            'hxsl'
        ],
        value: 'haxe'
    },
    {
        name: 'Elixir',
        alias: [
            'elixir',
            'ex',
            'exs'
        ],
        value: 'elixir'
    },
    {
        name: 'Verilog',
        alias: [
            'verilog',
            'v'
        ],
        value: 'verilog'
    },
    {
        name: 'Rust',
        alias: [
            'rust'
        ],
        value: 'rust'
    },
    {
        name: 'VHDL',
        alias: [
            'vhdl'
        ],
        value: 'vhdl'
    },
    {
        name: 'Sass',
        alias: [
            'sass'
        ],
        value: 'less'
    },
    {
        name: 'OCaml',
        alias: [
            'ocaml'
        ],
        value: 'ocaml'
    },
    {
        name: 'Dart',
        alias: [
            'dart'
        ],
        value: 'dart'
    },
    {
        name: 'CSS',
        alias: [
            'css'
        ],
        value: 'css'
    },
    {
        name: 'reStructuredText',
        alias: [
            'restructuredtext',
            'rst',
            'rest'
        ],
        value: 'rest'
    },
    {
        name: 'Kotlin',
        alias: [
            'kotlin'
        ],
        value: 'kotlin'
    },
    {
        name: 'D',
        alias: [
            'd'
        ],
        value: 'd'
    },
    {
        name: 'Octave',
        alias: [
            'octave'
        ],
        value: 'matlab'
    },
    {
        name: 'QML',
        alias: [
            'qbs',
            'qml'
        ],
        value: 'qml'
    },
    {
        name: 'Prolog',
        alias: [
            'prolog'
        ],
        value: 'prolog'
    },
    {
        name: 'FoxPro',
        alias: [
            'foxpro',
            'purebasic'
        ],
        value: 'purebasic'
    },
    {
        name: 'Scheme',
        alias: [
            'scheme',
            'scm'
        ],
        value: 'scheme'
    },
    {
        name: 'CUDA',
        alias: [
            'cuda',
            'cu'
        ],
        value: 'cpp'
    },
    {
        name: 'Julia',
        alias: [
            'julia',
            'jl'
        ],
        value: 'julia'
    },
    {
        name: 'Racket',
        alias: [
            'racket',
            'rkt'
        ],
        value: 'lisp'
    },
    {
        name: 'Ada',
        alias: [
            'ada',
            'ada95',
            'ada2005'
        ],
        value: 'ada'
    },
    {
        name: 'Tcl',
        alias: [
            'tcl'
        ],
        value: 'tcl'
    },
    {
        name: 'Mathematica',
        alias: [
            'mathematica',
            'mma',
            'nb'
        ],
        value: 'mathematica'
    },
    {
        name: 'Autoit',
        alias: [
            'autoit'
        ],
        value: 'autoit'
    },
    {
        name: 'StandardML',
        alias: [
            'standardmL',
            'sml',
            'standardml'
        ],
        value: 'sml'
    },
    {
        name: 'Objective-J',
        alias: [
            'objective-j',
            'objectivej',
            'obj-j',
            'objj'
        ],
        value: 'objectivec'
    },
    {
        name: 'Smalltalk',
        alias: [
            'smalltalk',
            'squeak',
            'st'
        ],
        value: 'smalltalk'
    },
    {
        name: 'Vala',
        alias: [
            'vala',
            'vapi'
        ],
        value: 'vala'
    },
    {
        name: 'LiveScript',
        alias: [
            'livescript',
            'live-script'
        ],
        value: 'livescript'
    },
    {
        name: 'XQuery',
        alias: [
            'xquery',
            'xqy',
            'xq',
            'xql',
            'xqm'
        ],
        value: 'xquery'
    },
    {
        name: 'PlainText',
        alias: [
            'text',
            'plaintext'
        ],
        value: 'text'
    },
    {
        name: 'Yaml',
        alias: [
            'yaml',
            'yml'
        ],
        value: 'yaml'
    },
    {
        name: 'GraphQL',
        alias: [
            'graphql'
        ],
        value: 'graphql'
    },
    {
        name: 'AppleScript',
        alias: [
            'applescript'
        ],
        value: 'applescript'
    },
    {
        name: 'Clojure',
        alias: [
            'clojure'
        ],
        value: 'clojure'
    },
    {
        name: 'Diff',
        alias: [
            'diff'
        ],
        value: 'diff'
    },
    {
        name: 'VisualBasic',
        alias: [
            'visualbasic'
        ],
        value: 'visual-basic'
    },
    {
        name: 'JSX',
        alias: [
            'jsx'
        ],
        value: 'jsx'
    },
    {
        name: 'TSX',
        alias: [
            'tsx'
        ],
        value: 'tsx'
    },
    {
        name: 'SplunkSPL',
        alias: [
            'splunk-spl'
        ],
        value: 'splunk-spl'
    },
    {
        name: 'Dockerfile',
        alias: [
            'docker',
            'dockerfile'
        ],
        value: 'dockerfile'
    },
    {
        name: 'HCL',
        alias: [
            'hcl',
            'terraform'
        ],
        value: 'hcl'
    },
    {
        name: 'NGINX',
        alias: [
            'nginx'
        ],
        value: 'nginx'
    },
    {
        name: 'Protocol Buffers',
        alias: [
            'protobuf',
            'proto'
        ],
        value: 'protobuf'
    },
    {
        name: 'TOML',
        alias: [
            'toml'
        ],
        value: 'toml'
    },
    {
        name: 'Handlebars',
        alias: [
            'handlebars',
            'mustache'
        ],
        value: 'handlebars'
    },
    {
        name: 'Gherkin',
        alias: [
            'gherkin',
            'cucumber'
        ],
        value: 'gherkin'
    },
    {
        name: 'ABAP',
        alias: [
            'abap'
        ],
        value: 'abap'
    },
    {
        name: 'Markdown',
        alias: [
            'markdown'
        ],
        value: 'markdown'
    }
];
module.exports["SUPPORTED_LANGUAGES"] = $a6db6a3439cd9017$export$7c77c3a9bb93870d;

});


//# sourceMappingURL=codeBlock.31024de6.js.map
